import { useState } from 'react';
import useMountEffect from './useMountEffect';

// The document's width excluding its vertical scrollbar, which is the room fixed overlays such as
// modals lay out in.
const getWindowWidth = () => document.documentElement.clientWidth;

/**
 * Tracks the window's layout width, updating as the window is resized.
 */
const useWindowWidth = (): number => {
	const [windowWidth, setWindowWidth] = useState(getWindowWidth);

	useMountEffect(() => {
		const handleResize = () => setWindowWidth(getWindowWidth());
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	});

	return windowWidth;
};

export default useWindowWidth;
